// 3_pages/index.js
// Homepage: wraps the news/blog items into a slider container placed after the
// footer banners.

/* Unused — kept for reference.
function moveFooterBanners() {
	if (!document.body.classList.contains("in-index")) {
		return;
	}
	let footerBanners = document.querySelector(".footer-banners");
	if (!footerBanners) return;

	let homepageGroupTitles = document.querySelectorAll(".homepage-group-title");
	if (!homepageGroupTitles || homepageGroupTitles.length < 3) return;

	// insert footer banners before the 3rd homepage group title
	homepageGroupTitles[2].parentNode.insertBefore(footerBanners, homepageGroupTitles[2]);
}
*/

/* moveFooterBanners(); */

export function init() {
	wrapBlogsInWrapper();
}

function wrapBlogsInWrapper() {
	if (!document.body.classList.contains("in-index")) {
		return;
	}

	const newsItems = document.querySelectorAll(".news-item");
	if (!newsItems || newsItems.length === 0) return;

	const homepageBlogWrapper = document.documentElement.querySelector(".homepage-blog-wrapper");

	const homepageBlogItemsContainer = document.createElement("div");
	homepageBlogItemsContainer.className = "homepage-blog-items-container";

	const homepageBlogItemsContainerWrapper = document.createElement("div");
	homepageBlogItemsContainerWrapper.className = "homepage-blog-items-container-wrapper";
	homepageBlogItemsContainerWrapper.appendChild(homepageBlogItemsContainer);

	// insert before 1st news item
	/* 		let firstNewsItem = newsItems[0];
		firstNewsItem.parentNode.insertBefore(homepageBlogWrapper, firstNewsItem); */

	newsItems.forEach((item) => {
		homepageBlogItemsContainer.appendChild(item);
	});
	homepageBlogItemsContainerWrapper.appendChild(homepageBlogItemsContainer);
	homepageBlogWrapper.appendChild(homepageBlogItemsContainerWrapper);

	const footerBanners = document.querySelector(".footer-banners");
	if (footerBanners) {
		//insert homepage blog wrapper after footer banners
		footerBanners.parentNode.insertBefore(homepageBlogWrapper, footerBanners.nextSibling);
	}

	homepageBlogWrapper.classList.add("has-blog-container");

	window.NAT.utils.initializeSliderElement(
		homepageBlogItemsContainerWrapper,
		homepageBlogItemsContainer,
		newsItems,
		"blog-slider",
		".image",
	);
	homepageBlogItemsContainer;
}
